module.exports = __webpack_public_path__ + "static/tech-team-78bf542398d69c4673a29da08510a569.png";